/**
 * api接口统一管理
 */
import { get, post, jsonp } from './http'

/**
 * 登录获取用户信息
 * @param {Object} p 请求参数
 */
export const getuserinfo = p => post('/api/v2/pc/getuserinfo', p)

/**
 * 退出登录
 * @param {Object} p 请求参数
 */
 export const logoutName = p => post('/api/v1/pc/logout', p)

/**
 * 获取新闻列表接口（GET）
 * @param {Object} p 请求参数
 */
export const getNewsList = p => get('/web/news/v2/getalllist', p)

/**
 * 获取新闻详情接口（GET）
 * @param {Object} p 请求参数
 */
export const getNewsDetails = p => get('/web/news/v2/selectdatabyid', p)

/**
 * 获取视频列表接口（GET）
 * @param {Object} p 请求参数
 */
export const getVideosList = p => get('/web/video/v2/getlistbyvtype', p)

/**
 * 获取视频详情接口（GET）
 * @param {Object} p 请求参数
 */
export const getVideosDetails = p => get('/web/video/v2/selectdatebyid', p)

/**
 * 获取图文教程详情接口（GET）
 * @param {Object} p 请求参数
 */
export const getGraphicTutorialDetails = p => get('/api/imagetext/v2/selectdatabyid', p)

/**
 * 获取安装包链接接口（GET）
 * @param {Object} p 请求参数
 */
export const getInstallPackUrl = p => get('/upgradePackage/infoall', p)

/**
 * 下载量统计
 * @param {Object} p 请求参数
 */
 export const getclicks = p => jsonp('/api/v1/log/packagedownload', p)

/**
 * 访问量统计
 * @param {Object} p 请求参数
 */
 export const getVisit = p => jsonp('/api/v1/log/visit', p)


 /**
  * 微信登录
  * @param {*} p
  * @returns
  */
 export const saveloginrecord = p => jsonp('/api/v1/pc/saveloginrecord', p)


 /**
  * 活动信息
  * @param {*} p
  * @returns
  */
 export const getlistActivity = p => post('/web/activitie/v2/getlist', p)

 /**
  * 摄影大赛落地页访问接口
  * @param {*} p
  * @returns
  */
 export const bhphotography = p => post('/web/activitie/v2/view', p)


/**
 * 企业会员咨询提交接口
 * @param {*} p
 * @returns
 */
export const addConsult = p => jsonp('/sales/order/addConsult', p)

/**
 * 摄影大赛作品数据
 * @param {*} p
 * @returns
 */
 export const getdetail = p => get('/api/v1/pc/activety/photo/getdetail', p)

 /**
 * 获取活动数据
 * @param {*} p
 * @returns
 */
  export const activetyData = p => get('/api/v1/pc/activety/photo/get', p)


/**
 * 账号登录
 * @param {*} p
 * @returns
 */
export const accountLogin = p => post('/api/v1/pc/pclogin', p)

/**
 * 验证码登录
 * @param {*} p
 * @returns
 */
export const checkcodeLogin = p => post('/api/v1/pc/checkcode', p)

/**
 * 获取验证码
 * @param {*} p
 * @returns
 */
export const sendCommonCode = p => post('/api/v1/pc/sendCommonCode', p)

/**
 * 获取vip/素材包/……列表
 * @param {*} p
 * @returns
 */
export const getVipListPage = p => get('/web/sales/vipprice/v2/listpage', p)
/*********   华为  ***********/
/**
 * 获取产品列表
 * @param {*} p
 * @returns
 */
export const getHuaweiProductList = p => get('/api/v3/sales/vipprice/list', p)

/**
 * 购买创建订单
 * @param {*} p
 * @returns
 */
export const createHuaweiPayOrder = p => jsonp('/api/v3/sales/huaweipay/createorder', p)

/**
 * 6.查询订单支付结果
 * @param {*} p
 * @returns
 */
export const getorderpaystatus = p => get('/api/v3/sales/huaweipay/getorderpaystatus', p)
/*********   华为  ***********/
/**
 * 优惠券查询
 * @param {*} p
 * @returns
 */
export const myDiscounts = p => get('/api/v1/sales/coupons/myDiscounts', p)

/**
 * 提交订单
 * @param {*} p
 * @returns
 */
export const qrcodediscounts = p => get('/wxpay/qrcodediscounts', p)

/**
 * 验证ios订单
 * @param {*} p
 * @returns
 */
export const applePayVerify = p => jsonp('/api/vi/app/iosgoods/applePayVerify', p)

/**
 * 支付回调
 * @param {*} p
 * @returns
 */
export const queryByOrderId = p => get('/wxpay/queryByOrderId', p)

/**
 * 联想
 * @param {*} p
 * @returns
 */
export const lenovoTrade = p => get('/lenovo/api/v1/pay/trade', p)

/**
 * h5支付
 * @param {*} p
 * @returns
 */
 export const payh5 = p => get('/wxpay/payh5', p)

/**
 * 联想大赛上传作品
 * @param {*} p
 * @returns
 */
export const worksUpload = p => post('/api/v1/pc/activety/photo/save', p)

/**
 * 邀请下载
 * @param {*} p
 * @returns
 */
export const invite = p => post('/api/v1/pc/invit', p)

export const getwxconfig = p => get('/api/v1/common/getwxconfig', p)

/**
 * 图文教程获取左侧数据
 * @param {*} p
 * @returns
 */
export const getLeftLits = p => get('/api/style/v2/getlist', p)

/**
 * 图文教程获取全部数据/获取二维码数据（通用）
 * @param {*} p
 * @returns
 */
export const getMultipleData = p => get('/api/v1/common/queryparambyname', p)

/**
 * 图文教程获取全部数据
 * @param {*} p
 * @returns
 */
export const getalllist = p => get('/api/imagetext/v2/getalllist', p)

/**
 * 创建360订单
 * @param {*} p
 * @returns
 */
export const threeSixtyCreateorder = p => jsonp('/api/v1/360pay/createorder', p)

/**
 * 360支付回调(通知支付结果)
 * @param {*} p
 * @returns
 */
export const threeSixtyGetorder = p => get('/api/v1/360pay/getorder', p)

/**
 * 获取生成的订单信息
 * lenovo/api/v1/pay/trade
 * @param {Object} p 请求参数
 * 参数说明
 * period       卡包标号
 * totalPrice   总价
 * unitPrice    单价
 * number       数量
 * bodyType     购买数据类型
 * ids          选用优惠券id列表字符串（可选）
 * lenovotoken  联想版悟空图像的联想token（可选）
 * source       来源固定值 70
 */
export const getLenovoPayInfo = p => get('/lenovo/api/v1/pay/trade', p)

